module.exports = __webpack_public_path__ + "img/apple_pick_wall_sit_original.a334d53e.jpg";